module.exports = __webpack_public_path__ + "static/img/first-page.c14de4cd.svg";